import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { takeLatest, put, all, delay } from "redux-saga/effects";
import history from "../../providers/history";
import { SetObject } from "../../providers/storage";
import { authenticationRequestService, changePasswordSaveRequestService, profileUserRequestService } from "./services";
import { authenticationFailure, authenticationRequest, authenticationSuccess, changePasswordSaveFailure, changePasswordSaveRequest, changePasswordSaveSucess, profileUserFailure, profileUserRequest, profileUserSuccess } from "./slice";
import { IAuthenticatedUser, IAuthenticationPayloadRequest, IAuthenticationResponse, IChangePassword, IChangePasswordResponse, IChangePasswordSaveRequestPayload, IProfileResponse } from "./types";

function* authenticationRequestSaga(
  action: PayloadAction<IAuthenticationPayloadRequest>
) {
  try {
    const authenticationResponse: AxiosResponse<IAuthenticationResponse> =
      yield authenticationRequestService(action);

    if (authenticationResponse.data.status) {
      const authenticatedUser: IAuthenticatedUser = {
        name: authenticationResponse.data.name || "",
        id: authenticationResponse.data.id,
        permissions: authenticationResponse.data.permissions,
        token: authenticationResponse.data.token,
      };

      SetObject("authenticatedUser", authenticatedUser);

      history.push("/");

      yield put(authenticationSuccess(authenticatedUser));
    } else {
      yield put(
        authenticationFailure({
          message:
            authenticationResponse.data.message || "Error trying authneticate",
        })
      );
    }
  } catch (error: any) {

    yield put(
      authenticationFailure({
        message: error.response?.data?.message || "Error trying authneticate",
      })
    );
  }
}

function* watchAuthenticationRequestSaga() {
  yield takeLatest(authenticationRequest.type, authenticationRequestSaga);
}

function* changePasswordSaveRequestSaga(action: PayloadAction<IChangePassword>) {
  try {
    const payloadChangePasword: IChangePasswordSaveRequestPayload = {
      password: action.payload.password,
      newPassword: action.payload.newPassword,
      confirmationPassword: action.payload.confirmationPassword,
    };
    const changePasswordSaveResponse: AxiosResponse<IChangePasswordResponse> = yield changePasswordSaveRequestService(payloadChangePasword);


    if (changePasswordSaveResponse.data.status) {
      yield put(changePasswordSaveSucess({
        ...action.payload,
        password: changePasswordSaveResponse.data.data.password,
      })
      );

      history.back();
      yield delay(50);

    }
    else {
      yield put(changePasswordSaveFailure({
        message:
          changePasswordSaveResponse.data.message || "Error trying to change password"
      }));
    }
  }
  catch (error: any) {

    yield put(
      changePasswordSaveFailure({
        message: error.response?.data?.message || "Error trying to get save new password"
      }));
  }
}

function* watchChangePasswordResquestSaga() {
  yield takeLatest(changePasswordSaveRequest.type, changePasswordSaveRequestSaga);
}

function* profileUserRequestSaga() {
  try {
    const profileResponse: AxiosResponse<IProfileResponse> = yield profileUserRequestService();

    if (profileResponse.data.status) {
      yield put(profileUserSuccess({
        id: profileResponse.data.data.id,
        name: profileResponse.data.data.name,
        permissions: [],
        token: '',
        email: profileResponse.data.data.email
      }))
    }
    else {
      yield put(profileUserFailure({
        message: profileResponse.data.message || 'Error when trying to get user profile'
      }));
    }
  }
  catch (error) {
    yield put(profileUserFailure({
      message: 'Error when trying to get user profile'
    }));
  }
}

function* watchProfileUserRequestSaga() {
  yield takeLatest(profileUserRequest.type, profileUserRequestSaga);
}

export default all([
  watchAuthenticationRequestSaga(),
  watchChangePasswordResquestSaga(),
  watchProfileUserRequestSaga(),
]);
